import { Tab } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import { SPOT_LIVE_SELECT_TABS } from "~/components/blocks/product/const";

export type VideoSpotLiveSeasonTabTitleProps = {
  /** 現在選択中のタブの値 */
  selectedTabValue: string;
  /** タブの切り替え処理 */
  onChangeTabValue: (v: string) => void;
  /**
   * シーズンタイプ
   * - TODO : エピソードタブは初期リリースの範囲外。実装着手できるようになったらコメントアウト外す
   */
  // seasonType: G_VideoSeasonType;
  /**
   * エピソードの合計数
   * - TODO : エピソードタブは初期リリースの範囲外。実装着手できるようになったらコメントアウト外す
   */
  // totalEpisodeLength: number;
};

/**
 * スポット配信 | 作品末端のTabTitle部分に関するコンポーネント
 * @param props {@link VideoSpotLiveSeasonTabTitleProps}
 */
export const VideoSpotLiveSeasonTabTitle = memo((props: VideoSpotLiveSeasonTabTitleProps) => {
  const { selectedTabValue, onChangeTabValue } = props;

  /** エピソードが1話以上だった場合、エピソードタブを表示すること */
  // const isEpisode = totalEpisodeLength > 0 && seasonType === G_VideoSeasonType.SpotLive;

  const tabTitle = [
    // isEpisode
    //   ? {
    //       tabLabel: `エピソード(${totalEpisodeLength})`,
    //       value: SPOT_LIVE_SELECT_TABS.EPISODE,
    //     }
    //   : undefined,

    {
      tabLabel: "作品情報",
      value: SPOT_LIVE_SELECT_TABS.PRODUCT_INFO,
    },
  ];

  /** `undefined`を除去した配列を生成する */
  // const tabOptions = tabTitle.flatMap((item) => {
  //   return item === undefined ? [] : [item];
  // });

  return (
    <Tab
      name="VideoSpotLiveSeason-TabBlocks"
      selectValue={selectedTabValue}
      options={tabTitle}
      onChangeTab={(targetValue) => onChangeTabValue(targetValue)}
    />
  );
});

VideoSpotLiveSeasonTabTitle.displayName = "VideoSeasonTabTitle";
